import { render, staticRenderFns } from "./ZoneItem.vue?vue&type=template&id=2d58ced1&scoped=true"
import script from "./ZoneItem.vue?vue&type=script&lang=js"
export * from "./ZoneItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d58ced1",
  null
  
)

export default component.exports